import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import student_Store from "../store/student_store";
import ExportCSV from "../functions/ExportCSV";

function Report_Page() {
  // Student Store
  const students = student_Store((state) => state.students);
  const getStudentsReport = student_Store((state) => state.getStudentsReport);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
      id: 1,
    },
    {
      name: "Request",
      // selector: (row) => (new Date(row?.created_at ?? '')?.toLocaleString()?.replace(',', '-') ?? ''),
      selector: (row) =>
        new Date(row?.attends?.[0]?.created_at ?? "")
          ?.toLocaleString()
          ?.replace(",", "-") ?? "",
      id: 2,
    },
    {
      name: "Response",
      selector: (row) =>
        (row?.attends?.[0]?.response_at ?? "") == ""
          ? ""
          : new Date(row?.attends?.[0]?.response_at ?? "")
              ?.toLocaleString()
              ?.replace(",", "-"),
      id: 3,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      id: 4,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      id: 5,
    },
    {
      name: "Major",
      selector: (row) => row?.majors?.[0]?.name ?? "",
      id: 6,
    },
    {
      name: "Cohort",
      selector: (row) => row?.cohorts?.[0]?.name ?? "",
      id: 7,
    },
    {
      name: "status",
      selector: (row) => row?.attends?.[0]?.statusRequest,
      id: 8,
    },
    {
      name: "Course 1",
      selector: (row) => row?.["courses"]?.[0] ?? "",
      id: 9,
    },
    {
      name: "Course 2",
      selector: (row) => row?.["courses"]?.[1] ?? "",
      id: 10,
    },
    {
      name: "Course 3",
      selector: (row) => row?.["courses"]?.[2] ?? "",
      id: 11,
    },
    {
      name: "Course 4",
      selector: (row) => row?.["courses"]?.[3] ?? "",
      id: 12,
    },
    {
      name: "Course 5",
      selector: (row) => row?.["courses"]?.[4] ?? "",
      id: 13,
    },
    {
      name: "Course 6",
      selector: (row) => row?.["courses"]?.[5] ?? "",
      id: 14,
    },
    {
      name: "Course 7",
      selector: (row) => row?.["courses"]?.[6] ?? "",
      id: 15,
    },
    {
      name: "Course 8",
      selector: (row) => row?.["courses"]?.[7] ?? "",
      id: 16,
    },
    {
      name: "Course 9",
      selector: (row) => row?.["courses"]?.[8] ?? "",
      id: 17,
    },
    {
      name: "Course 10",
      selector: (row) => row?.["courses"]?.[9] ?? "",
      id: 18,
    },
    {
      name: "Course 11",
      selector: (row) => row?.["courses"]?.[10] ?? "",
      id: 19,
    },
    {
      name: "Course 12",
      selector: (row) => row?.["courses"]?.[11] ?? "",
      id: 20,
    },
    {
      name: "Course 13",
      selector: (row) => row?.["courses"]?.[12] ?? "",
      id: 21,
    },
    {
      name: "Course 14",
      selector: (row) => row?.["courses"]?.[13] ?? "",
      id: 22,
    },
    {
      name: "Course 15",
      selector: (row) => row?.["courses"]?.[14] ?? "",
      id: 23,
    },
    {
      name: "Course 16",
      selector: (row) => row?.["courses"]?.[15] ?? "",
      id: 24,
    },
  ];
  let [mydata, setMydata] = useState([]);

  useEffect(() => {
    getStudentsReport();
  }, []);

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  function onChange(e) {
    let word = e.target.value;
    const result = students.data.filter(
      (student) =>
        (student.name &&
          student.name.toLowerCase().includes(word.toLowerCase())) ||
        student.attends?.[0]?.statusRequest
          .toLowerCase()
          .includes(word.toLowerCase()) ||
        student.attends?.[0]?.created_at
          .toLocaleString()
          .toLowerCase()
          .includes(word.toLowerCase()) ||
        student.email.includes(word) ||
        student?.id == word
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : students.data;

    if (arr != undefined) {
      reportStructure(arr);
    }
    arr.forEach((obj, index) => {
      obj["adv-name"] = obj.attends?.[0]?.supervisor?.name ?? "";
      obj["adv-email"] = obj.attends?.[0]?.supervisor?.email ?? "";
      obj["howAttend"] = obj.attends?.[0]?.howAttend ?? "";
      obj["location"] = obj["howAttend"];
      delete obj["howAttend"];

      obj["Request"] =
        new Date(obj?.attends?.[0]?.created_at ?? "")
          ?.toLocaleString()
          ?.replace(",", "-") ?? "";
      if ((obj?.attends?.[0]?.response_at ?? "") != "")
        obj["Response"] =
          new Date(obj?.attends?.[0]?.response_at ?? "")
            ?.toLocaleString()
            ?.replace(",", "-") ?? "";
      else obj["Response"] = "";
      obj["statuss"] = obj.attends?.[0]?.statusRequest ?? "";

      delete obj.image;
      delete obj.roles;
      delete obj.created_at;
      delete obj.status;
      delete obj.attends;
      obj.id = index + 1;
      obj.majors = obj?.majors?.[0]?.name ?? "";
      obj.cohorts = obj?.cohorts?.[0]?.name ?? "";
    });

    // return

    arr.forEach((obj) => {
      Object.defineProperty(
        obj,
        "course1",
        Object.getOwnPropertyDescriptor(obj, "courses")
      );
      delete obj["courses"];

      // obj['course1'] = ''
      obj["course2"] = "";
      obj["course3"] = "";
      obj["course4"] = "";
      obj["course5"] = "";
      obj["course6"] = "";
      obj["course7"] = "";
      obj["course8"] = "";
      obj["course10"] = "";
      obj["course11"] = "";
      obj["course12"] = "";
      obj["course13"] = "";
      obj["course14"] = "";
      obj["course15"] = "";
      obj["course16"] = "";
      obj["course17"] = "";
    });

    ExportCSV(arr, "students_report");
  }

  const reportStructure = (arr) => {
    return Array.prototype.forEach.call(arr, (student, i) => {
      let mainCounter = 0;
      let mainCategoryCounter = 7;
      let altCounter = 14;
      let courses = [];
      Array.prototype.forEach.call(student?.attends ?? [], (attend, j) => {
        const course = attend?.courseset?.course ?? "";
        let courseCodeAndName =
          (course?.name ?? "") + " " + (course?.code ?? "");
        courseCodeAndName = course?.code ?? "";
        const statusname = attend?.coursestatus?.name ?? "";
        if ([3, 5].includes(attend?.coursestatus?.id ?? "")) {
          courses[mainCounter++] = courseCodeAndName;
        } else if ([9, 12, 15, 18].includes(attend?.coursestatus?.id ?? "")) {
          courses[mainCategoryCounter++] = courseCodeAndName;
        } else if (
          [4, 19, 20, 21, 22].includes(attend?.coursestatus?.id ?? "")
        ) {
          if (4 != (attend?.coursestatus?.id ?? "")) {
            courses[altCounter++] = courseCodeAndName;
          } else {
            courses[altCounter++] = courseCodeAndName;
          }
        } else if ([19, 20, 21, 22].includes(attend?.coursestatus?.id ?? "")) {
          courses[altCounter++] = courseCodeAndName;
        }
      });
      student["courses"] = courses;
    });
  };

  const reportStructure_old = (arr) => {
    return Array.prototype.forEach.call(arr, (student, i) => {
      let mainCounter = 0
      let mainCategoryCounter = 7
      let altCounter = 14
      let courses = []
      Array.prototype.forEach.call(student?.attends ?? [], (attend, j) => {
        const course = attend?.courseset?.course ?? ''
        let courseCodeAndName = (course?.name ?? '') + ' ' + (course?.code ?? '')
        const statusname = attend?.coursestatus?.name ?? ''
        if ( [3,5].includes (attend?.coursestatus?.id ?? '')) {
          courses[mainCounter++] = courseCodeAndName;
        }
        else if ([9, 12, 15, 18].includes(attend?.coursestatus?.id ?? '')) {
          courses[mainCategoryCounter++] = "* " + statusname + " " + courseCodeAndName;
        }
        else if ([4, 19, 20, 21, 22].includes(attend?.coursestatus?.id ?? '')) {
          if (4 != (attend?.coursestatus?.id??'')){
          courses[altCounter++] = "* " + statusname + " " + courseCodeAndName;
          }else{
            courses[altCounter++] = courseCodeAndName;
          }
        }
        else if ([ 19, 20, 21, 22].includes(attend?.coursestatus?.id ?? '')) {
          courses[altCounter++] = "* " + statusname + " " + courseCodeAndName;
        }
      })
      student['courses'] = courses
    })
  }

  let alternativeCourses = [];
  let arr = mydata.length > 0 ? mydata : students.data;

  if (arr != undefined) {
    arr = reportStructure(arr);
  }

  return (
    <>
      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>

        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>

      <DataTable
        title="Students"
        columns={columns}
        data={mydata?.length > 0 ? mydata : students.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : students?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  );
}

export default Report_Page;
